/** List chat photos belong to their uploader, including in another user's shared project. */
export function listPromptUploadOwner(project: { projectType?: string | null; userId?: string | null } | undefined, callerId: string | null | undefined): string | undefined {
  return (project?.projectType === 'LIST' ? callerId : project?.userId) || undefined;
}
